import { useEffect } from "react";

const useDraggableContent = (contentId: string) => {
  useEffect(() => {
    const element = document.getElementById(contentId);
    element?.addEventListener("mousedown", initDrag, false);
    element?.addEventListener("touchstart", initDrag, false);
    let offset = [0, 0];

    function initDrag(e: any) {
      console.log("draggable called");

      // e.stopPropagation();
      const clientY =
        e.clientY ||
        (e.targetTouches[0] ? e.targetTouches[0].pageY : e.changedTouches[e.changedTouches.length - 1].pageY);
      const clientX =
        e.clientX ||
        (e.targetTouches[0] ? e.targetTouches[0].pageX : e.changedTouches[e.changedTouches.length - 1].pageX);

      if (element) {
        offset = [element.offsetLeft - clientX, element.offsetTop - clientY];
      }

      window.addEventListener("touchmove", Drag, false);
      window.addEventListener("touchend", stopDrag, false);

      window.addEventListener("mousemove", Drag, false);
      window.addEventListener("mouseup", stopDrag, false);
    }

    function Drag(e: any) {
      e.preventDefault();
      const clientY =
        e.clientY ||
        (e.targetTouches[0] ? e.targetTouches[0].pageY : e.changedTouches[e.changedTouches.length - 1].pageY);
      const clientX =
        e.clientX ||
        (e.targetTouches[0] ? e.targetTouches[0].pageX : e.changedTouches[e.changedTouches.length - 1].pageX);

      if (element) {
        const parentRect = element.parentElement?.getBoundingClientRect() as DOMRect;
        const rect = element.getBoundingClientRect();
        const maxTop = 0 - (element.offsetHeight - rect.height) / 2;
        const maxLeft = 0 - (element.offsetWidth - rect.width) / 2;
        const minTop = parentRect.height - element.offsetHeight - (rect.height - element.offsetHeight) / 2 + 6;
        const minLeft = parentRect.width - element.offsetWidth - (rect.width - element.offsetWidth) / 2;

        element.style.left = Math.min(maxLeft, Math.max(minLeft, clientX + offset[0])) + "px"; // 26 is app-padding}
        element.style.top = Math.min(maxTop, Math.max(minTop, clientY + offset[1])) + "px"; // 26 is app-padding
      }
    }
    function stopDrag() {
      window.removeEventListener("mousemove", Drag, false);
      window.removeEventListener("mouseup", stopDrag, false);
      window.removeEventListener("touchmove", Drag, false);
      window.removeEventListener("touchend", stopDrag, false);
    }
  }, []);
};

export default useDraggableContent;
